<script>
  import { onMount, onDestroy } from 'svelte';
  import { broadcaster, videoPlayer } from './broadcast-store';

  let playerContainer;
  let guidelines;
  let cropRect;
  let resizeObserver;

  $: $videoPlayer && $broadcaster.userMediaStream && setStream($broadcaster.userMediaStream);
  $: $videoPlayer?.srcObject && !$broadcaster.userMediaStream && setStream(null);

  export const clearStream = () => {
    $videoPlayer.srcObject = null;
  };

  const setStream = (s) => {
    if (s?.id !== $videoPlayer.srcObject?.id) {
      $videoPlayer.srcObject = s;
    }
  };

  onMount(async () => {
    addVideoPlayer();
    resizeObserver = new ResizeObserver(() => {
      calcGuidelines();
    });
    resizeObserver.observe(playerContainer);
  });

  onDestroy(async () => {
    if ($videoPlayer) {
      $videoPlayer.removeEventListener('canplaythrough', onVideoCanPlay);
      $videoPlayer.removeEventListener('resize', onVideoResize);
    }
    resizeObserver.unobserve(playerContainer);
  });

  const addVideoPlayer = () => {
    let v = $videoPlayer;
    if (!$videoPlayer) {
      v = document.createElement('video');
      v.autoplay = true;
      v.muted = true;
      v.setAttribute('playsinline', 'playsinline');
      v.setAttribute('webkit-playsinline', 'webkit-playsinline');
      v.classList.add('video');
      videoPlayer.set(v);
    }
    v.addEventListener('canplaythrough', onVideoCanPlay);
    v.addEventListener('resize', onVideoResize);
    playerContainer.appendChild(v);
    if ($broadcaster.videoCanPlay) {
      v.play();
      calcGuidelines();
    }
  };

  const onVideoResize = () => {
    calcGuidelines();
  };

  const onVideoCanPlay = () => {
    broadcaster.update((s) => ({ ...s, videoCanPlay: true }));
  };

  const handleWindowResize = () => calcGuidelines();

  const calcGuidelines = (e) => {
    if (
      $videoPlayer &&
      playerContainer &&
      $videoPlayer.videoWidth > 2 &&
      $videoPlayer.videoHeight > 2
    ) {
      const bounds = playerContainer.getBoundingClientRect();
      const aspectRatio = $videoPlayer.videoWidth / $videoPlayer.videoHeight;

      let h = bounds.height;
      let w = h * aspectRatio;

      if (h * aspectRatio > bounds.width) {
        w = bounds.width;
        h = w / aspectRatio;
      }

      let cw = h / aspectRatio;
      let ch = h;

      cropRect.style = `height: ${ch}px; width: ${cw}px;`;
      guidelines.style = `height: ${h}px; width: ${w}px;`;
    }
  };
</script>

<svelte:window on:resize|passive={handleWindowResize} />

<div class="video-container">
  <div
    class="player-container"
    bind:this={playerContainer}
    class:hidden={!$broadcaster.videoCanPlay || $broadcaster.flippingCam}
  >
    <div class="video-guidelines" bind:this={guidelines}>
      <div class="filler" />
      <div class="crop-rect" bind:this={cropRect} />
      <div class="filler" />
    </div>
  </div>
</div>

<style src="./cameraPreview.scss"></style>
